var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { useLink } from "../../hooks/useLink";
import { makeStyles } from "../../styles/index";
import { ChevronLeft } from "../../icons/index";
import { useTheme } from "../../hooks/useTheme";
var styles = function (theme) { return ({
    root: {
        height: 48,
        padding: 0,
        display: 'inline-flex',
        flex: '0 0 auto',
        alignItems: 'center',
        border: 'solid',
        borderColor: 'transparent',
        borderWidth: theme.shape.borderWidth.normal,
        borderLeft: 'none',
        borderRadius: '0 24px 24px 0',
        fontSize: 18,
        fontWeight: 500,
        justifyContent: 'center',
        outline: 0,
        position: 'relative',
        textDecoration: 'none',
        transitionProperty: 'box-shadow, transform, opacity',
        userSelect: 'none',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        '&:disabled': {
            pointerEvents: 'none',
        },
    },
    icon: {},
    label: {
        color: 'inherit',
        alignItems: 'center',
        display: 'flex',
        flex: '1 0 auto',
        justifyContent: 'inherit',
        lineHeight: 'normal',
        position: 'relative',
        marginRight: theme.spacing(2),
    },
    light: {
        color: theme.palette.light.text.primary,
        backgroundColor: theme.palette.light.background.paper,
        '&:disabled': {
            color: theme.palette.light.text.disabled,
        },
        '&:hover': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
        },
        '&:active': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dark: {
        color: theme.palette.dark.text.primary,
        backgroundColor: theme.palette.dark.background.paper,
        '&:disabled': {
            color: theme.palette.dark.text.disabled,
        },
        '&:hover': {
            color: theme.palette.primary.light,
            borderColor: theme.palette.primary.light,
        },
        '&:active': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.primary.light,
            backgroundColor: theme.palette.primary.light,
        },
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnBackButton' });
export var BackButton = function (props) {
    var label = props.label, propClassName = props.className, others = __rest(props, ["label", "className"]);
    var classes = useStyles();
    var Component = useLink(props, 'button');
    var type = useTheme(props).type;
    var className = classNames(classes.root, classes[type], propClassName);
    return (React.createElement(Component, __assign({ className: className }, others),
        React.createElement(ChevronLeft, { className: classes.icon }),
        label && React.createElement("span", { className: classes.label }, "\u3082\u3069\u308B")));
};
